import { Card, CardContent, Box, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";

interface AddEmployeeCardProps {
  onClick: () => void;
  disabled?: boolean;
}

export default function AddEmployeeCard({ onClick, disabled = false }: AddEmployeeCardProps) {
  return (
    <Card
      onClick={disabled ? undefined : onClick}
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        borderRadius: 2,
        border: "2px dashed",
        borderColor: "divider",
        bgcolor: "background.default",
        cursor: disabled ? "default" : "pointer",
        transition: "all 0.2s",
        minHeight: 240,
        "&:hover": disabled
          ? {}
          : {
              borderColor: "primary.main",
              bgcolor: "primary.50",
              transform: "translateY(-4px)",
              boxShadow: 4,
            },
      }}
    >
      <CardContent
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
        }}
      >
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            bgcolor: disabled ? "action.disabledBackground" : "primary.light",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "all 0.2s",
          }}
        >
          <Add
            sx={{
              fontSize: 32,
              color: disabled ? "action.disabled" : "primary.main",
            }}
          />
        </Box>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            color: disabled ? "text.disabled" : "text.primary",
          }}
        >
          Add New Employee
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            textAlign: "center",
          }}
        >
          Add a new team member
        </Typography>
      </CardContent>
    </Card>
  );
}
